
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("52id1", function(module, exports) {

$parcel$export(module.exports, "useQuickstartEligible", () => $c90a71d49e407199$export$6d1ffb649c1cfb52);

var $gwFzn = parcelRequire("gwFzn");

var $1ytiN = parcelRequire("1ytiN");

var $8Lx5S = parcelRequire("8Lx5S");
var $bQm3c = parcelRequire("bQm3c");

var $1amdO = parcelRequire("1amdO");

var $hl0fg = parcelRequire("hl0fg");

var $ivb8S = parcelRequire("ivb8S");

var $dBcar = parcelRequire("dBcar");
var $3hLsK = parcelRequire("3hLsK");

var $dPJCf = parcelRequire("dPJCf");

var $9wGTI = parcelRequire("9wGTI");

var $aWwYt = parcelRequire("aWwYt");

var $6mKj3 = parcelRequire("6mKj3");

var $jNJeR = parcelRequire("jNJeR");

var $lRAO1 = parcelRequire("lRAO1");
const $c90a71d49e407199$export$6d1ffb649c1cfb52 = ()=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const { isSiteAdmin: isSiteAdmin } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    const { isMigratedUser: isMigratedUser, isMigratedUserReady: isMigratedUserReady } = (0, $1amdO.useMigratedUser)({
        skip: !(0, $9wGTI.fg)('cc_onboarding_experience')
    });
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { data: data } = (0, $ivb8S.useGetOnboardingState)([
        (0, $3hLsK.ORIGIN_ATTRIBUTES),
        (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN
    ]);
    const state = (0, $ivb8S.deserializeState)(data);
    const checkAllowedRoutes = {
        selector: (name)=>(0, $lRAO1.isNameAllowed)(name)
    };
    const isAllowlistPath = (0, $dPJCf.useRouteName)(checkAllowedRoutes);
    const { width: windowWidth } = (0, $hl0fg.useWindowSize)();
    const isWidthThresholdMet = windowWidth >= (0, $jNJeR.QS_WINDOW_WIDTH_THRESHOLD);
    const isAnonymousUser = !userId || !isLicensed;
    const isFoundingAdmin = state?.isFoundingAdmin;
    const isTarget = isAllowlistPath && !isAnonymousUser && isWidthThresholdMet;
    // -------- JSW XFlow Quickstart Targeting
    let isJSWXFlowUser;
    const attributes = state?.attributes ?? '{}';
    try {
        isJSWXFlowUser = JSON.parse(attributes)?.originProduct === 'jira';
    } catch (e) {
        isJSWXFlowUser = false;
    }
    const isNthUserQSV2Eligible = isTarget && !isFoundingAdmin && (0, $9wGTI.fg)('cc_onboarding_experience');
    const isAdminQuickStartV2Eligible = isTarget && isFoundingAdmin && (0, $9wGTI.fg)('cc_onboarding_experience');
    const isMigrationsQuickstartEligible = isTarget && !isSiteAdmin && isMigratedUserReady && isMigratedUser && (0, $9wGTI.fg)('cc_onboarding_experience');
    const isJswXflowUserQSEligible = isJSWXFlowUser && isTarget && (0, $9wGTI.fg)('cc_onboarding_experience');
    const isObjectSidebarCurrentlyShowing = isObjectSidebarShown && (0, $9wGTI.fg)('confluence_frontend_object_sidebar');
    const isQuickstartEligible = ()=>{
        return isTarget && // Allow list paths
        !isFoundingAdmin && // Home Takeover experiment is to replace Quickstart
        !(0, $6mKj3.expValEqualsNoExposure)('cc_onboarding_nth_user_home_takeover', 'cohort', 'experiment') && // core QS experiment FFs
        (isJswXflowUserQSEligible || isAdminQuickStartV2Eligible || isMigrationsQuickstartEligible || isNthUserQSV2Eligible) && !isObjectSidebarCurrentlyShowing && (0, $9wGTI.fg)('cc_onboarding_experience') // Master FF
        ;
    };
    return {
        isTarget: isTarget,
        isSiteAdmin: isSiteAdmin,
        isOnboardingEligible: (0, $9wGTI.fg)('cc_onboarding_experience'),
        isQuickstartEligible: isQuickstartEligible,
        isNthUserQSV2Eligible: isNthUserQSV2Eligible,
        isAdminQuickStartV2Eligible: isAdminQuickStartV2Eligible,
        isMigrationsQuickstartEligible: isMigrationsQuickstartEligible,
        isJswXflowUserQSEligible: isJswXflowUserQSEligible
    };
};

});
parcelRegister("1amdO", function(module, exports) {

$parcel$export(module.exports, "useMigratedUser", () => $03efcd2cc339475b$export$fbf00738c7847f18);

var $gwFzn = parcelRequire("gwFzn");

var $hK4Zq = parcelRequire("hK4Zq");
var $lDMQ2 = parcelRequire("lDMQ2");

var $inPa6 = parcelRequire("inPa6");

var $8Lx5S = parcelRequire("8Lx5S");
var $bQm3c = parcelRequire("bQm3c");

var $kAcNG = parcelRequire("kAcNG");

var $3hLsK = parcelRequire("3hLsK");

var $ivb8S = parcelRequire("ivb8S");

var $70ZoW = parcelRequire("70ZoW");
const $03efcd2cc339475b$export$fbf00738c7847f18 = ({ skip: skip = false } = {})=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const fireMigrationsAnalytics = (0, $gwFzn.useCallback)((action, migrationAttributes)=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: 'useMigratedUser',
                actionSubject: 'isMigratedUser',
                action: action,
                attributes: migrationAttributes
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    let isMigratedUser = false;
    // Fetch onboarding state so we can see if the user is already migrated or untagged
    const { data: data, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)(Object.values([
        (0, $3hLsK.QUICKSTART_STATE_KEYS).IS_MIGRATED_USER_V2
    ]), !isLicensed || skip);
    const { isMigratedUserV2: isMigratedUserV2 } = (0, $ivb8S.deserializeState)(data);
    const isUntaggedUser = !onboardingStateLoading && isMigratedUserV2 === undefined;
    // Skip useSitePersonalizationQuery if the user is already migrated or is an untagged user
    const eligibleToBeTaggedAsMigratedUser = isMigratedUserV2 || isUntaggedUser;
    const skipQuery = skip || onboardingStateLoading || !eligibleToBeTaggedAsMigratedUser;
    const { loading: sitePersonalizationQueryLoading, error: sitePersonalizationQueryError, attributes: attributes } = (0, $kAcNG.useSitePersonalizationQuery)({
        cloudId: cloudId,
        skip: skipQuery
    });
    const sitePersonalizationDataAttributes = attributes?.reduce((obj, item)=>({
            ...obj,
            [item.name]: item.value
        }), {});
    const entitlementType = sitePersonalizationDataAttributes?.[0, $70ZoW.ENTITLEMENT_TYPE_KEY];
    const activationDate = sitePersonalizationDataAttributes?.[0, $70ZoW.ACTIVATION_DATE_KEY];
    const confluenceMigrationStatus = sitePersonalizationDataAttributes?.[0, $70ZoW.CONFLUENCE_MIGRATION_STATUS_KEY];
    const shouldSkip = skipQuery || onboardingStateLoading || onboardingStateError || sitePersonalizationQueryLoading || sitePersonalizationQueryError;
    const confluenceFirstMigrationSignalDate = sitePersonalizationDataAttributes?.[0, $70ZoW.CONFLUENCE_FIRST_MIGRATION_SIGNAL_DATE_KEY];
    /**
	 * Setting the variables based off of traits:
	 * - Use the signal date if V2 traits are backfilled
	 * - Otherwise fall back to entitlement type and activation date
	 */ const isMigratedTraitActive = confluenceMigrationStatus === 'true';
    const migrationsStartDate = isMigratedTraitActive ? confluenceFirstMigrationSignalDate : activationDate;
    const extendedTrialEligible = entitlementType === (0, $70ZoW.MIGRATIONS_ENTITLEMENT_TYPE);
    const isMigratedSite = isMigratedTraitActive || extendedTrialEligible;
    (0, $gwFzn.useEffect)(()=>{
        if (shouldSkip) return;
        if (!isMigratedSite) {
            // if the trait hasn't been populated yet, skip setting the key until we have V2 traits
            // the exception is when the user has been previously tagged as migrated and no longer qualifies
            if (confluenceMigrationStatus !== undefined || isMigratedUserV2) {
                if (isMigratedUserV2 !== false) setOnboardingState({
                    key: (0, $3hLsK.QUICKSTART_STATE_KEYS).IS_MIGRATED_USER_V2,
                    value: 'false'
                });
            }
        } else if (migrationsStartDate) {
            const migrationPeriodEligible = $03efcd2cc339475b$var$getMigrationPeriodEligible(migrationsStartDate);
            // The user is not within the migrations expiry period, set state to False and return False in the hook
            if (!migrationPeriodEligible) {
                if (isMigratedUserV2 !== false) setOnboardingState({
                    key: (0, $3hLsK.QUICKSTART_STATE_KEYS).IS_MIGRATED_USER_V2,
                    value: 'false'
                });
            } else if (isMigratedUserV2 !== true) {
                /**
				 * The user has met all eligibility requirements to be considered a migrated user
				 *
				 * Fire analytics for untagged users
				 * Set isMigratedUser to True in onboarding state, and return True in the hook
				 */ setOnboardingState({
                    key: (0, $3hLsK.QUICKSTART_STATE_KEYS).IS_MIGRATED_USER_V2,
                    value: 'true'
                });
                fireMigrationsAnalytics((0, $70ZoW.ADDED_MIGRATED_USER_TAG), {
                    isMigratedUser: isMigratedUser
                });
            }
        }
    }, [
        shouldSkip,
        isMigratedSite,
        migrationsStartDate,
        isMigratedUserV2,
        confluenceMigrationStatus,
        setOnboardingState,
        isMigratedUser,
        fireMigrationsAnalytics
    ]);
    if (shouldSkip) return {
        isMigratedUser: false,
        isMigratedUserReady: true,
        error: sitePersonalizationQueryError,
        skipQuery: skipQuery
    };
    /**
	 * Setting the migrated user logic starts here:
	 *
	 * The first disqualifying V2 logic - confluence migration status (trait) is false AND the entitlement type is not extended trial
	 * If already tagged as migrated in onboarding state, fire endMigratedSiteEligible and set to False (previously confluence_migration_status = true, or entitlement_type = extended_trial)
	 * If no prior tag in onboarding state, fire migratedSiteIneligible and set to False
	 *
	 * Edge case: if the V2 traits aren't backfilled yet, don't set state so we can run again next time and temporarily return False
	 * Edge case: if the V2 traits aren't backfilled but the user was previously tagged as migrated with extended trial, set state to False
	 */ if (!isMigratedSite) return {
        isMigratedUser: false,
        isMigratedUserReady: !sitePersonalizationQueryLoading && !sitePersonalizationQueryError,
        error: sitePersonalizationQueryError,
        skipQuery: skipQuery
    };
    /**
	 * Check the second disqualifying condition: whether users fall outside the migrations expiry period
	 * Note: migrationsStartDate can either be activation date OR signal date depending on confluence_migration_status
	 */ if (migrationsStartDate) {
        const migrationPeriodEligible = $03efcd2cc339475b$var$getMigrationPeriodEligible(migrationsStartDate);
        if (!migrationPeriodEligible) return {
            isMigratedUser: false,
            isMigratedUserReady: !sitePersonalizationQueryLoading && !sitePersonalizationQueryError,
            error: sitePersonalizationQueryError,
            skipQuery: skipQuery
        };
        isMigratedUser = true;
    }
    return {
        isMigratedUser: isMigratedUser,
        isMigratedUserReady: !onboardingStateLoading && !sitePersonalizationQueryLoading,
        error: onboardingStateError || sitePersonalizationQueryError,
        skipQuery: skipQuery
    };
};
const $03efcd2cc339475b$var$getMigrationPeriodEligible = (migrationsStartDate)=>{
    const migrationsExpiryDate = (0, $hK4Zq.default)(new Date(migrationsStartDate), (0, $70ZoW.MONTHS_UNTIL_MIGRATIONS_EXPIRY));
    return (0, $lDMQ2.default)(new Date(), migrationsExpiryDate);
};

});
parcelRegister("70ZoW", function(module, exports) {

$parcel$export(module.exports, "ACTIVATION_DATE_KEY", () => $20798c77a4bb4e4c$export$ad0bfc929cc937d1);
$parcel$export(module.exports, "CONFLUENCE_MIGRATION_STATUS_KEY", () => $20798c77a4bb4e4c$export$9b831d7b67c9cef6);
$parcel$export(module.exports, "CONFLUENCE_FIRST_MIGRATION_SIGNAL_DATE_KEY", () => $20798c77a4bb4e4c$export$b5dd58b19cf27e36);
$parcel$export(module.exports, "ENTITLEMENT_TYPE_KEY", () => $20798c77a4bb4e4c$export$24602edc13166b9f);
$parcel$export(module.exports, "MONTHS_UNTIL_MIGRATIONS_EXPIRY", () => $20798c77a4bb4e4c$export$45908fa17d98f76);
$parcel$export(module.exports, "MIGRATIONS_ENTITLEMENT_TYPE", () => $20798c77a4bb4e4c$export$d2975d7ea6671559);
$parcel$export(module.exports, "ADDED_MIGRATED_USER_TAG", () => $20798c77a4bb4e4c$export$bcdb6d949f725537);
const $20798c77a4bb4e4c$export$ad0bfc929cc937d1 = 'confluence.ondemand.activationDate';
const $20798c77a4bb4e4c$export$9b831d7b67c9cef6 = 'confluence_migration_status';
const $20798c77a4bb4e4c$export$b5dd58b19cf27e36 = 'confluence_first_migration_signal_date';
const $20798c77a4bb4e4c$export$24602edc13166b9f = 'confluence_entitlement_type';
const $20798c77a4bb4e4c$export$45908fa17d98f76 = 3;
const $20798c77a4bb4e4c$export$d2975d7ea6671559 = 'EXTENDED_TRIAL';
const $20798c77a4bb4e4c$export$bcdb6d949f725537 = 'addedMigratedUserTag';

});


parcelRegister("jNJeR", function(module, exports) {

$parcel$export(module.exports, "QS_WINDOW_WIDTH_THRESHOLD", () => $0ba04a616e2bedd7$export$a1dbb294430bee02);
$parcel$export(module.exports, "CONFLUENCE_ONBOARDING_QUICKSTART", () => $0ba04a616e2bedd7$export$a653ff2042908ec3);
$parcel$export(module.exports, "CONFLUENCE_ONBOARDING_QUICKSTART_DRAWER", () => $0ba04a616e2bedd7$export$bfca18197eb98eaa);
$parcel$export(module.exports, "CONFLUENCE_ONBOARDING_QUICKSTART_BUTTON", () => $0ba04a616e2bedd7$export$8e7e5010e27a79df);
$parcel$export(module.exports, "CONFLUENCE_ONBOARDING_QUICKSTART_BUTTON_DRAWER", () => $0ba04a616e2bedd7$export$576fbf166bcae0b0);
$parcel$export(module.exports, "CONFLUENCE_ONBOARDING_QUICKSTART_CTA", () => $0ba04a616e2bedd7$export$549db28183a986ea);
$parcel$export(module.exports, "CONFLUENCE_ONBOARDING_QUICKSTART_CAROUSEL_ACTION", () => $0ba04a616e2bedd7$export$68ef35ce157f7396);
$parcel$export(module.exports, "WELCOME_TO_CONFLUENCE_VIDEOS", () => $0ba04a616e2bedd7$export$c7ee3293fdd6b532);
const $0ba04a616e2bedd7$export$a1dbb294430bee02 = 1130;
const $0ba04a616e2bedd7$export$a653ff2042908ec3 = 'confluenceOnboardingQuickstart';
const $0ba04a616e2bedd7$export$bfca18197eb98eaa = 'confluenceOnboardingQuickstartDrawer';
const $0ba04a616e2bedd7$export$8e7e5010e27a79df = 'confluenceOnboardingQuickstartButton';
const $0ba04a616e2bedd7$export$576fbf166bcae0b0 = 'confluenceOnboardingQuickstartButtonDrawer';
const $0ba04a616e2bedd7$export$549db28183a986ea = 'confluenceOnboardingQuickstartCta';
const $0ba04a616e2bedd7$export$68ef35ce157f7396 = 'confluenceOnboardingQuickstartCarouselAction';
const $0ba04a616e2bedd7$export$c7ee3293fdd6b532 = {
    en: 'https://player.vimeo.com/progressive_redirect/playback/676035490/rendition/1080p?loc=external&signature=1ce9207d5a6a8957d85834336f59c42c45b099c8320d3c60cdbfe2f526136ec2',
    jp: 'https://player.vimeo.com/progressive_redirect/playback/738398214/rendition/1080p/file.mp4?loc=external&signature=b1d49a7d7a517d7d245e0d4018b4f4dba97d97c481ced019807dc97fa45631db',
    de: 'https://player.vimeo.com/progressive_redirect/playback/738398180/rendition/1080p/file.mp4?loc=external&signature=29b5a66a0b5a5bc2ef65c6d11048328650ae4c963b29877ac9ab5abac47ef4a4',
    cn: 'https://player.vimeo.com/progressive_redirect/playback/738398158/rendition/1080p/file.mp4?loc=external&signature=3f0f01307ffd26e49240387deb9b703d45cf59359b862dd8d1b68542c5d35166',
    br: 'https://player.vimeo.com/progressive_redirect/playback/738398131/rendition/1080p/file.mp4?loc=external&signature=36299800fdbeefd42b2da49a887e804dbb9c2df500acaab07627f8d01521770f',
    ru: 'https://player.vimeo.com/progressive_redirect/playback/738398112/rendition/1080p/file.mp4?loc=external&signature=26c0364851f5cb0d38d4396e5067473d825e8e633fd0cc204982fd3773f235b2',
    es: 'https://player.vimeo.com/progressive_redirect/playback/738398078/rendition/1080p/file.mp4?loc=external&signature=596aa393f72a91d1485f7b36edf5a9e03e25a1350a923a870181c7cd1e92c21c',
    nl: 'https://player.vimeo.com/progressive_redirect/playback/738398054/rendition/1080p/file.mp4?loc=external&signature=3927a84841c8b9bc1812797a72885a30c45c1749f661bbd15c01f09b067b5915',
    kr: 'https://player.vimeo.com/progressive_redirect/playback/738398022/rendition/1080p/file.mp4?loc=external&signature=ab4e580c57f4f9ca990f1cd917a55a43ad0ed3f3c87cdc3e5592634eb5a6b213',
    pl: 'https://player.vimeo.com/progressive_redirect/playback/738397991/rendition/1080p/file.mp4?loc=external&signature=869e4a87dc2f8d5bd49843d6066c8370dd3f1ca0a2a41e7d9334c9b63bab3d07',
    it: 'https://player.vimeo.com/progressive_redirect/playback/738397952/rendition/1080p/file.mp4?loc=external&signature=1b7a167fff2b5c656f349ed89aac9c88a9224329d7c68835c76e519a7a5b713b',
    fr: 'https://player.vimeo.com/progressive_redirect/playback/738397906/rendition/1080p/file.mp4?loc=external&signature=41b38194e902626c4a55d6ca7ec5ab4e267b395be78bcd15f5f1d0e86b083081'
};

});

parcelRegister("lRAO1", function(module, exports) {

$parcel$export(module.exports, "isNameAllowed", () => $fdef0bf5106d057e$export$4d77218734541822);
/**
 * Matches patterns that are either allowlisted or blocklisted, and returns whether or not it should be allowed
 * to show the quickstart feature
 */ const $fdef0bf5106d057e$export$4d77218734541822 = (name)=>{
    const allowlistPattern = [
        /VIEW_BLOG_DATE_LEGACY/
    ];
    const blocklistPatterns = [
        /EMBED_VIEW/,
        /WHITEBOARD_HOME/,
        /WHITEBOARD_BOARD/,
        /LEGACY/,
        /ADMIN/,
        // this is the legacy calendar - different from "MY_CALENDAR" name
        /^CALENDAR$/
    ];
    if (!name) return false;
    const isAllowlistPath = blocklistPatterns.every((pattern)=>!pattern.test(name)) || allowlistPattern.some((pattern)=>pattern.test(name));
    return isAllowlistPath;
};

});


parcelRegister("6zNhq", function(module, exports) {

$parcel$export(module.exports, "useQuickstartState", () => $c1f87eafffcacf0a$export$99ee8470aaea932a);

var $ivb8S = parcelRequire("ivb8S");

var $3hLsK = parcelRequire("3hLsK");
const $c1f87eafffcacf0a$export$6295562e03abbf61 = {
    state: {
        openTaskId: '',
        isPanelOpen: false,
        isDismissed: true,
        isLoading: true,
        isError: false,
        error: null,
        createSpaceCompleted: true,
        createPageCompleted: false,
        inviteTeammateCompleted: false,
        readConfluenceGuideCompleted: false,
        siteTourVideoComplete: false,
        sharePageCompleted: false,
        integrationCompleted: false,
        helpCompleted: false,
        collaborateCompleted: false,
        homeTourCompleted: false,
        spaceModalCompleted: true,
        homeModalCompleted: true,
        editorTutorialTaskCompleted: false,
        jswXFlowModalCompleted: false,
        jswXFlowInvitePeopleModalOpen: false,
        jswXflowInvitePeopleNudgeCompleted: false,
        spaceTourCompleted: false,
        jswConfIntroCompleted: true,
        qsv2InviteTeammateCompleted: false,
        qsv2IntegrationCompleted: false,
        migrationsWelcomeCompleted: false,
        migrationsNewPageCompleted: false,
        migrationsEditAndCustomizeContentCompleted: false,
        migrationsCollaborateCompleted: false,
        migrationsFindAndOrganizePagesCompleted: false,
        openComponentId: undefined,
        qsv2SpotlightCompleted: true
    }
};
const $c1f87eafffcacf0a$var$successState = {
    qsv2SpotlightCompleted: false,
    spaceModalCompleted: false,
    homeModalCompleted: false,
    jswConfIntroCompleted: false
};
const $c1f87eafffcacf0a$export$99ee8470aaea932a = ({ skip: skip = false } = {})=>{
    const { data: data, error: onboardingStateError, loading: onboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)(Object.values({
        ...(0, $3hLsK.QUICKSTART_STATE_KEYS)
    }), skip);
    if (skip) return {
        ...$c1f87eafffcacf0a$export$6295562e03abbf61.state,
        isLoading: false,
        isError: false,
        error: null
    };
    return {
        ...$c1f87eafffcacf0a$export$6295562e03abbf61.state,
        ...onboardingStateLoading || Boolean(onboardingStateError) ? {} : $c1f87eafffcacf0a$var$successState,
        ...(0, $ivb8S.deserializeState)(data),
        isLoading: Boolean(onboardingStateLoading),
        isError: Boolean(onboardingStateError),
        error: onboardingStateError ?? null
    };
};

});


//# sourceMappingURL=ObjectSidebarControl.8f0e45d9.js.map
